/**
 * Shared categorical color assignment for venues, used by the price-history
 * chart lines and the depth-ladder venue dots so a venue is the SAME color
 * everywhere on a page.
 *
 * Palette: dataviz reference categorical set (dark-mode steps), validated
 * against our panel surface #111722 — all checks pass (worst adjacent CVD
 * ΔE 26.3, all ≥3:1 contrast). Hues are assigned in FIXED order over the
 * alphabetically-sorted venue list, never cycled; venues beyond the palette
 * fold to neutral gray (identity then relies on the label, per the relief
 * rule).
 */
export const VENUE_SERIES = [
  "#3987e5", // blue
  "#199e70", // aqua
  "#c98500", // yellow
  "#9085e9", // violet
  "#e66767", // red
  "#d95926", // orange
] as const;

export const VENUE_FOLD = "#8b93a7"; // neutral fold color beyond 6 venues

/** Stable name→color map for one view: alphabetical venues, fixed slot order. */
export function venueColorMap(names: Iterable<string>): Map<string, string> {
  const sorted = [...new Set(names)].sort((a, b) => a.localeCompare(b));
  const m = new Map<string, string>();
  sorted.forEach((name, i) => {
    m.set(name, i < VENUE_SERIES.length ? VENUE_SERIES[i] : VENUE_FOLD);
  });
  return m;
}
